module.exports = __webpack_public_path__ + "img/BigVLogoNew.0de67613.png";